import { NextRouter } from 'next/router';

interface ISearchParams {
  entryCode: string,
  email: string,
  verificationToken: string,
  videoId: string,
  source?: string,
}

export const getSearchParams = (router: NextRouter): ISearchParams => ({
  email: (router.query.email as string)?.replace(/ /g, '+'),
  entryCode: router.query.entry_code as string,
  verificationToken: router.query.verification_token as string,
  videoId: router.query.v as string,
  source: router.query.source as string | undefined,
});
